import images from "@assets/images";
import React from "react";
import { Image, View } from "react-native";
import Ball from "./ball";
import Bonus from "./bonus";
import Collect from "./collect";
import HotDeals from "./hotdeals";
import LeaderBoard from "./leaderboard";
import Mission from "./mission";
import ResponsiveProvider from "./provider";
import ShopButton from "./shop";
import useStyles from "./styles.css";

const BottomNav = () => {
  const styles = useStyles();

  return (
    <ResponsiveProvider>
      <>
        <View pointerEvents="box-none" style={styles.wrapcenter}>
          <Image
            source={{uri: images.hud_bot}}
            style={[styles.style_navbottom]}
            resizeMode="stretch"
          />
          <View style={styles.leftStyle}>
            <Bonus />
            <Collect />
          </View>
          <View style={styles.middleStyle}>
            <ShopButton />
          </View>
          <View style={[styles.rightStyle]}>
            <View style={styles.rightStyleCenter}>
              <HotDeals />
              <LeaderBoard />
              <Ball />
              <Mission />
            </View>
          </View>
        </View>
      </>
    </ResponsiveProvider>
  );
};

export default React.memo(BottomNav);
